import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface SecurityState {
  serverPublicKey: string | null;
  serverPrivateKey: string | null;
  localPublicKey: string | null;
  localPrivateKey: string | null;
}

const initialState: SecurityState = {
  serverPublicKey: null,
  serverPrivateKey: null,
  localPublicKey: null,
  localPrivateKey: null,
};

const securitySlice = createSlice({
  name: 'security',
  initialState,
  reducers: {
    /** Merge in whatever tokens/keys a request returned. */
    setSecurity: (state, action: PayloadAction<Partial<SecurityState>>) => {
      Object.assign(state, { ...action.payload });
    },
    clearSecurity: () => initialState,
  },
});

export const { setSecurity, clearSecurity } = securitySlice.actions;
export default securitySlice;
